import { Select, SelectProps } from 'antd';
import { useGetImplementQuery } from 'app/api';
import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const ImplementSelect: FC<IProps> = props => {
  const { t } = useTranslation();

  const envId = useSelector(selectSelectedEnvId) as number;
  const companyId = useSelector(selectSelectedCompanyId);
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);

  const { data: implementResponse, isFetching } = useGetImplementQuery(
    {
      companyId,
      companyGroupId,
      envId,
      pageSize: 1000,
      currentPage: 0,
      filters: {},
      sort: {},
    },
    { skip: !envId },
  );

  const options: IOption[] | undefined = implementResponse?.content?.map(
    implement => ({
      value: implement.id,
      label: implement.model,
    }),
  );
  return (
    <Select
      options={options}
      loading={isFetching}
      placeholder={t('Common.Implement', 'Implement')}
      {...props}
    />
  );
};

export default ImplementSelect;
